import React from "react"

interface IProps {
  icon?: string,
  placeholder?: string,
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
  value?: string | number | readonly string[],
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void,
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  inputStyle?: React.CSSProperties,
  className?: string
}

export default ({ icon, placeholder, onChange, value, onKeyDown, onClick, inputStyle, className }: IProps) => {
  return (
    <div className={"radius-4 flexed " + className} style={{ backgroundColor: 'rgba(255, 255, 255, .4)' }}>
      <div className={(icon && "separator ") + "inline-blocked flex-1"}>
        <input type="search" placeholder={placeholder} onChange={onChange} value={value}
          onKeyDown={e => onKeyDown && onKeyDown(e)}
          className="bd-none bg-none dropdown py-12 px-16 font-10 iran-sans w-100"
          style={{ height: 45, ...inputStyle }} />
      </div>
      {icon && <button className="bd-none bg-none icon-button mx-16 p-0" onClick={(e) => onClick && onClick(e)}>
        <img className="icon-sm valign-mid button" src={icon} alt="" />
      </button>}
    </div>
  )
}
